import { api, ApiError } from "utils/api";
import { useAsync } from "utils/hooks";
import { Ticket } from "../types";

const ticketCategories = [
  "Incorrect Information",
  "Inappropriate Information",
  "Scam Project",
];

type CreateTicketFormData = {
  category: typeof ticketCategories[number];
  notes: string;
};

type CreateTicketRequest = CreateTicketFormData & {
  reviewableId: string;
  reviewableType: string;
};

/**
 * Async API call for creating ticket for a project
 */
const postCreateTicket = (request: CreateTicketRequest) =>
  api.post<Ticket>(`/tickets`, {
    body: JSON.stringify(request),
  });

/**
 * Custom hook to create ticket for a project and manage state
 */
const useCreateTicket = (reviewableId: string, reviewableType: string) => {
  const { run, ...query } = useAsync<Ticket, ApiError>();

  const createTicket = (formData: CreateTicketFormData) =>
    run(postCreateTicket({ reviewableId, reviewableType, ...formData }));

  return {
    createTicket,
    ...query,
  };
};

export type { CreateTicketFormData };
export { useCreateTicket, ticketCategories };
